/** Directory columns — shared by VisitorDirectoryFilters and VisitorTable. */

const VISITOR_BASE_COLUMN_DEFS = [
  { id: "visitor_id", label: "Visitor ID", defaultVisible: true },
  { id: "entry_date", label: "Date", defaultVisible: true },
  { id: "visitor_name", label: "Visitor Name", defaultVisible: true },
  { id: "mobile_number", label: "Mobile", defaultVisible: true },
  { id: "purpose_name", label: "Purpose", defaultVisible: true },
  { id: "person_to_meet_name", label: "Person To Meet", defaultVisible: true },
  { id: "in_time", label: "In Time", defaultVisible: true },
  { id: "out_time", label: "Out Time", defaultVisible: true },
  { id: "status", label: "Status", defaultVisible: true },
  { id: "actions", label: "Action", defaultVisible: true },
];

/** Office, reception, and custom roles — no Registered By column. */
export const VISITOR_OFFICE_COLUMN_DEFS = [...VISITOR_BASE_COLUMN_DEFS];

/** Admin control — includes Registered By. */
export const VISITOR_ADMIN_COLUMN_DEFS = [
  ...VISITOR_BASE_COLUMN_DEFS.slice(0, 9),
  { id: "created_by_name", label: "Registered By", defaultVisible: true },
  { id: "actions", label: "Action", defaultVisible: true },
];

export function getVisitorColumnDefs(isAdmin) {
  return isAdmin ? VISITOR_ADMIN_COLUMN_DEFS : VISITOR_OFFICE_COLUMN_DEFS;
}
